import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { isServer } from '@mos/client/shared/utils'
import { of } from 'rxjs'
import { AuthRepository } from '../auth.repository'

export const canActivateNotAuth: CanActivateFn = () => {
	if (isServer) {
		return of(true)
	}

	const authRepository = inject(AuthRepository)

	const authState = authRepository.state
	if (!authState) {
		return of(true)
	}

	if (!authState.token) {
		return of(true)
	}

	return of(false)
}
